import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CreatePayByLinkLiability } from '../models/create-pay-by-link-liability.model';
import { map } from 'rxjs/operators';
import { PaymentService } from '../services/payment.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LegacyGuard implements CanActivate {
  constructor(private router: Router, private paymentService: PaymentService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const queryParamMap = next.queryParams as CreatePayByLinkLiability;

    if (environment.maintenance) {
      this.router.navigate(['/maintenance']);
    }

    return this.paymentService.validateToken(queryParamMap).pipe(
      map(res => {
        const { clientName, clientSurname, email } = next.queryParams;

        const queryParams: Params = {
          name: clientName,
          surname: clientSurname,
          email,
          type: res.upgradedVersion ? 'balance' : null
        };

        return this.router.createUrlTree(['/', res.token], {
          queryParams
        });
      })
    );
  }
}
